export default __webpack_public_path__ + "static/media/7.609dc5ba.png";